import { luckyCardApi } from "@/api/luckyCardApi";
import { ChooseLuckyCardScreenDataDomain, mapChooseLuckyCardScreenDataDtoToDomain } from "@/types/ChooseLuckyCardScreenData";
import { QuestionStatistics } from "@/types/QuestionStatistics";

interface LuckyCardRepository {
    getLuckyCards: () => Promise<ChooseLuckyCardScreenDataDomain>;
    chooseCard: (index: number) => Promise<void>;
    getStatistics: () => Promise<QuestionStatistics>;
}

export const luckyCardRepository: LuckyCardRepository = {

    getLuckyCards: async (): Promise<ChooseLuckyCardScreenDataDomain> => {
        const response = await luckyCardApi.getLuckyCard();
        return mapChooseLuckyCardScreenDataDtoToDomain(response);
    },

    chooseCard: async (index: number) => await luckyCardApi.chooseCard(index),

    getStatistics: async (): Promise<QuestionStatistics> => {
        const response = await luckyCardApi.getStatistics();
        return response;
    }
    
}
